import axios from 'axios'
import http from '@/services/http'

let cancelProductionSummary = null

export default {
  namespaced: true,
  actions: {
    async getProductionSummary({ dispatch, commit }) {
      await dispatch('cancelProductionSummary')
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      cancelProductionSummary = source
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        const res = await http.get('production_summary', { cancelToken: source.token })
        return res
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    },
    cancelProductionSummary() {
      if (cancelProductionSummary) {
        cancelProductionSummary.cancel()
      }
    }
  }
}